export default "__VITE_ASSET__c8uzit_H__ 400w, __VITE_ASSET__9MFAoXNS__ 800w, __VITE_ASSET__wPJfEXrG__ 1200w";